{
  "uigCartDetails": {
    "proceedToCheckout": "Ga verder",
    "cartName": "winkelwagen #{{code}}"
  },
  "uigCartItems": {
    "id": "ID",
    "le": "LE:",
    "description": "omschrijving",
    "itemPrice": "Prijs per stuk",
    "quantity": "Aantal",
    "total": "Totaalprijs",
    "products": "Art."
  },
  "fastEntry": {
    "title": "Snelinvoer",
    "hint": "Hier kunt u het artikel direct invullen.",
    "errors": {
      "invalidCode": "Er kon  geen artikel met  Artikelnaam \"{{productCode}}\" gevonden worden.",
      "zeroQty": "Art.Nr.: {{productCode}} - Verkoop niet langer mogelijk wegens volumebeperking.",
      "notesMaxLength": "Art.Nr.: {{productCode}} - De notitie is niet toegevoegd. Maximale lengte is bereikt.",
      "notListed": "Art.Nr.: {{productCode}} - Het product staat niet voor u in de lijst."
    },
    "placeholders": {
      "articleNo": "Art. Nr.",
      "quantity": "0",
      "note": "Notitie"
    },
    "buttons": {
      "submit": "Artikel toevoegen"
    },
    "addEntryConfirmation": "Het artikel is toegevoegd."
  },
  "cartWishlist": {
    "title": "Verlanglijst",
    "submit": "In de winkelwagen",
    "empty": "Er staan geen artikelen in uw verlanglijst."
  },
  "notes": {
    "noteAdd": "Notitie",
    "noteLabel": "Notitie",
    "modalTitle": "Item noot toevoegen of wijzigen",
    "edit": "Bewerk noot:",
    "save": "Overnemen",
    "errorLabel": "Error: \"{{errMsg}}\"",
    "updateSuccess": "Notitie is succesvol bijgewerkt!"
  },
  "shippingNote": {
    "label": "Toelichting:",
    "text": "vanaf 450,00 orderwaarde geen verzendkosten!"
  },
  "productImport": {
    "importTitle": "Artikel-import",
    "importText": "Hier kunt u bestelgegevens uit een eigen aangemaakt csv bestand overnemen.",
    "description": "Here you can import order data from an external file.",
    "select": "Select file",
    "noFileSelected": "Niets geselecteerd",
    "buttons": {
      "import": "Start Import",
      "select": "Select file"
    },
    "importSuccess": "Alle artikelen zijn succesvol geïmporteerd"
  },
  "cartExport": {
    "cartFilename": "Winkelwagen",
    "errorExportCart": "The cart could not be exported."
  },
  "addToCartLayer": {
    "goToCart": "Ga naar winkelwagen",
    "removeItem": "Artikel uit winkelwagen verwijderen"
  },
  "emptyCart": {
    "deleteAll": "Alle artikelen in de winkelwagen verwijderen?",
    "yes": "Ja",
    "no": "Nee",
    "error": "Producten in de winkelwagen konden niet worden verwijderd.",
    "title": "Leeg winkelmandje",
    "noEntries": "Uw winkelwagen is al leeg."
  },
  "vendorGroups": {
    "orderTotal": "Totaal bestelling",
    "vendor": "Leverancier",
    "numberOfEntries": "Aantal posities",
    "numberOfPieces": "Totaal aantal",
    "cartTotal": "Totaal artikelwaarde",
    "vendorTotal":"Waarde van artikelen",
    "deliveryCost": "Vrachtkosten",
    "note": "Hint"
  }
}
